import type { ModalFuncProps } from 'ant-design-vue'
import Confirm from './confirm.vue'
import { useEmptyModal } from '~/hooks/useModal/modals/empty'

export const useTransferModal = (
  options: ModalFuncProps & { headers?: Record<string, string> }
) => {
  const model = useEmptyModal({
    content: (
      <Confirm
        onOk={() => {
          options.onOk?.()
        }}
        onCancel={() => {
          options.onCancel?.()
          model.destroy()
        }}
      />
    ),
    width: 420,
  })
}
